var _defs, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    className: "logo-with-gradient",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC8523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#ED7745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#ED7545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#E95D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E85448"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#a)",
    fillRule: "evenodd",
    points: "0 0 0 36.201 33.604 36.201 33.604 31.948 4.359 31.948 4.359 4.253 45.641 4.253 45.641 36.201 50 36.201 50 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBox);
export default __webpack_public_path__ + "static/media/logoBox.6064791fd3cc4235b70c097a61f37cce.svg";
export { ForwardRef as ReactComponent };